// API 服务配置
const API_BASE_URL = 'https://global-recruit.vertu.com/api/v1';

// 通用请求函数
async function apiRequest<T>(
  url: string,
  options: RequestInit = {}
): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${url}`, {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  });

  if (!response.ok) {
    throw new Error(`API请求失败: ${response.status}`);
  }

  return response.json();
}

// 招聘岗位相关接口
export interface Job {
  id: number;
  job_title: string;
  education_requirement?: string;
  experience_years?: string;
  salary_range?: string;
  country: string;
  city: string;
  state: string;
  work_location_detail?: string;
  vacation_schedule?: string;
  benefits_description?: string;
  other_requirements?: string;
  company_info: string;
  status: string;
  resume_count: number;
  created_at: string;
  updated_at: string;
}

export interface JobListResponse {
  total: number;
  jobs: Job[];
}

export const jobAPI = {
  // 获取所有岗位
  getJobs: async (skip = 0, limit = 20, recruitingOnly = false): Promise<JobListResponse> => {
    const params = new URLSearchParams({
      skip: skip.toString(),
      limit: limit.toString(),
      recruiting_only: recruitingOnly.toString()
    });
    return apiRequest<JobListResponse>(`/jobs/?${params}`);
  },

  // 获取招聘中的岗位
  getRecruitingJobs: async (skip = 0, limit = 20): Promise<JobListResponse> => {
    const params = new URLSearchParams({
      skip: skip.toString(),
      limit: limit.toString()
    });
    return apiRequest<JobListResponse>(`/jobs/recruiting/list?${params}`);
  },

  // 获取单个岗位详情
  getJob: async (jobId: number): Promise<Job> => {
    return apiRequest<Job>(`/jobs/${jobId}`);
  },

  // 搜索岗位
  searchJobs: async (
    keyword?: string,
    country?: string,
    city?: string,
    state?: string,
    locationQuery?: string,
    recruitingOnly = true, 
    skip = 0, 
    limit = 20
  ): Promise<JobListResponse> => {
    const params = new URLSearchParams({
      skip: skip.toString(),
      limit: limit.toString(),
      recruiting_only: recruitingOnly.toString()
    });
    
    if (keyword) params.append('keyword', keyword);
    if (country) params.append('country', country);
    if (city) params.append('city', city);
    if (state) params.append('state', state);
    if (locationQuery) params.append('location_query', locationQuery);
    
    return apiRequest<JobListResponse>(`/jobs/search/?${params}`);
  }
};

// 认证相关接口（保留但不使用）
export const authAPI = {
  login: async (username: string, password: string) => {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    
    return apiRequest<{ access_token: string; token_type: string }>('/auth/login', {
      method: 'POST',
      body: formData,
      headers: {}, // 清空Content-Type让浏览器自动设置
    });
  }
};
